import "./Footer.css";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
    const location = useLocation();

    const locations = [
        {
            title: "United Kingdom",
            address: "124–128 City Road\nLondon EC1V 2NX",
        },
        {
            title: "United States",
            address: "807 N Upper Broadway, Suite 300\nCorpus Christi, TX 78401",
        },
        {
            title: "Australia",
            address: "Suite 1, Level 22, 66 Goulburn Street\nSydney NSW 2000",
        },
    ];

    const handleHomeClick = (e) => {
        if (location.pathname === "/") {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-columns">
                    <div className="footer-column">
                        <Link to="/" onClick={handleHomeClick}>
                            <svg
                                preserveAspectRatio="xMidYMid meet"
                                data-bbox="0 0 73.7 73.7"
                                viewBox="0 0 73.7 73.7"
                                xmlns="http://www.w3.org/2000/svg"
                                data-type="color"
                                role="presentation"
                                aria-hidden="true"
                                aria-label=""
                            >
                                <g>
                                    <path
                                        d="M0 0v26.2h1.1c2.3 0 3.3-.5 4.7-1.1 1.7-.8 3.8-1.7 7.6-1.7s5.9.9 7.6 1.7c1.4.6 2.4 1.1 4.7 1.1s3.3-.5 4.7-1.1c1.7-.8 3.8-1.7 7.6-1.7s5.9.9 7.6 1.7c1.4.6 2.4 1.1 4.7 1.1s3.3-.5 4.7-1.1c1.7-.8 3.8-1.7 7.6-1.7v7c-2.3 0-3.3.5-4.7 1.1-1.7.8-3.8 1.7-7.6 1.7s-5.9-.9-7.6-1.7c-1.4-.6-2.4-1.1-4.7-1.1s-3.3.5-4.7 1.1c-1.7.8-3.8 1.7-7.6 1.7s-5.9-.9-7.6-1.7c-1.4-.6-2.4-1.1-4.7-1.1s-3.3.5-4.7 1.1c-1.7.8-3.8 1.7-7.6 1.7H0v8h1.1c2.3 0 3.3-.5 4.7-1.1 1.7-.8 3.8-1.7 7.6-1.7s5.9.9 7.6 1.7c1.4.6 2.4 1.1 4.7 1.1s3.3-.5 4.7-1.1c1.7-.8 3.8-1.7 7.6-1.7s5.9.9 7.6 1.7c1.4.6 2.4 1.1 4.7 1.1s3.3-.5 4.7-1.1c1.7-.8 3.8-1.7 7.6-1.7v7c-2.3 0-3.3.5-4.7 1.1-1.7.8-3.8 1.7-7.6 1.7s-5.9-.9-7.6-1.7c-1.4-.6-2.4-1.1-4.7-1.1s-3.3.5-4.7 1.1c-1.7.8-3.8 1.7-7.6 1.7s-5.9-.9-7.6-1.7c-1.4-.6-2.4-1.1-4.7-1.1s-3.3.5-4.7 1.1c-1.7.8-3.8 1.7-7.6 1.7H0v8h1.1c2.3 0 3.3-.5 4.7-1.1 1.7-.8 3.8-1.7 7.6-1.7s5.9.9 7.6 1.7c1.4.6 2.4 1.1 4.7 1.1s3.3-.5 4.7-1.1c1.7-.8 3.8-1.7 7.6-1.7s5.9.9 7.6 1.7c1.4.6 2.4 1.1 4.7 1.1s3.3-.5 4.7-1.1c1.7-.8 3.8-1.7 7.6-1.7v7c-2.3 0-3.3.5-4.7 1.1-1.7.8-3.8 1.7-7.6 1.7s-5.9-.9-7.6-1.7c-1.4-.6-2.4-1.1-4.7-1.1s-3.3.5-4.7 1.1c-1.7.8-3.8 1.7-7.6 1.7s-5.9-.9-7.6-1.7c-1.4-.6-2.4-1.1-4.7-1.1s-3.3.5-4.7 1.1c-1.7.8-3.8 1.7-7.6 1.7H0v10.5h73.7V0z"
                                        fill="#179dca"
                                        data-color="1"
                                    ></path>
                                </g>
                            </svg>
                        </Link>
                    </div>

                    <div className="footer-column">
                        <div className="footer-header">LOCATIONS</div>

                        <div className="locations">
                            {locations.map((loc, index) => (
                                <div key={index} className="location">
                                    <div className="location-title">{loc.title}</div>

                                    <div className="location-address">
                                        {loc.address.split("\n").map((line, lineIndex) => (
                                            <span key={lineIndex}>
                                                {line.split(" ").map((word, wordIndex) => (
                                                    <span key={wordIndex}>{word}&nbsp;</span>
                                                ))}
                                                <br />
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="footer-column">
                        <div className="footer-header">CONTACT</div>

                        <a href="mailto:hello@river.capital">hello@river.capital</a>
                    </div>

                    <div className="footer-column">
                        <div className="footer-header">FOLLOW US</div>

                        <Link
                            to="https://www.linkedin.com/company/rivercapitalgroup/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/images/logos/linked-in.png"
                                alt="LinkedIn"
                                className="linked-in"
                            />
                        </Link>
                    </div>
                </div>

                <div className="footer-bottom">
                    <span>&copy; {new Date().getFullYear()} by River</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
